export default {"src":"/_next/static/media/ship-sticks-text-only-dark.3299c94b.svg","height":16,"width":67,"blurWidth":0,"blurHeight":0};